module.exports = __webpack_public_path__ + "img/1.00a375de.png";